<template>
    <div class="custom-node" :class="{ 'selected': selected }">
        <div class="node-header">
            <div class="d-flex align-center">
                <v-avatar size="24" :color="data.color || 'primary'" class="me-2" variant="tonal">
                    <v-icon size="small" :color="data.color || 'primary'">{{ data.icon || 'mdi-cog' }}</v-icon>
                </v-avatar>
                <strong>{{ label }}</strong>
            </div>
            <!-- Delete button -->
            <!-- <v-btn icon="mdi-close" variant="text" size="x-small" density="compact" @click.stop="onDelete"
                class="delete-btn" color="grey"></v-btn> -->
        </div>

        <div class="node-content">
            <!-- Status Chips Row -->
            <div class="status-chips">
                <v-chip v-if="data.sendMail" size="x-small" color="primary" variant="flat" class="me-1 mb-1">
                    <v-icon start size="small">mdi-email</v-icon>
                    Email
                </v-chip>
                <v-chip v-if="data.sendSms" size="x-small" color="success" variant="flat" class="me-1 mb-1">
                    <v-icon start size="small">mdi-message-text</v-icon>
                    SMS
                </v-chip>
            </div>

            <div v-if="!data.sendMail && !data.sendSms" class="text-caption text-grey text-center py-2">
                No actions configured
            </div>

            <div class="divider my-2"></div>

            <div v-if="data.jobType === WORKFLOW_NODE_TYPES.NOTIFICATION" class="summary-info">
                <span class="label">
                    <v-icon size="x-small" class="me-1">mdi-lightning-bolt</v-icon>
                    Trigger
                </span>
                <span class="value">{{ data.triggerEvent }}</span>
            </div>

            <div v-else class="summary-info">
                <span class="label">
                    <v-icon size="x-small" class="me-1">mdi-clock-outline</v-icon>
                    Timing
                </span>
                <span class="value">{{ data.durationValue }} {{ data.durationUnit }} before</span>
            </div>
        </div>

        <!-- Handles -->
        <Handle type="target" position="top" class="custom-handle" />
        <Handle type="source" position="bottom" class="custom-handle" />
    </div>
</template>

<script>
import { Handle, useVueFlow } from '@vue-flow/core'
import { WORKFLOW_NODE_TYPES } from '../../taskEngine/constants'

export default {
    name: 'CustomNode',
    components: {
        Handle
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            default: 'Node'
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const { removeNodes } = useVueFlow()
        return { removeNodes }
    },
    data() {
        return {
            WORKFLOW_NODE_TYPES
        }
    },
    methods: {
        onDelete() {
            this.removeNodes(this.id)
        }
    }
}
</script>

<style scoped>
.custom-node {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    width: 220px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    font-family: 'Inter', sans-serif;
    transition: all 0.2s ease;
}

.custom-node:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
}

.custom-node.selected {
    border: 2px solid #2196f3;
    box-shadow: 0 0 0 4px rgba(33, 150, 243, 0.1);
}

.node-header {
    background: #ffffff;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    font-size: 14px;
}

.delete-btn {
    opacity: 0.4;
    transition: opacity 0.2s;
}

.delete-btn:hover {
    opacity: 1;
    color: #f44336 !important;
}

.node-content {
    padding: 12px;
}

.status-chips {
    display: flex;
    flex-wrap: wrap;
    min-height: 24px;
}

.divider {
    height: 1px;
    background-color: #f0f0f0;
    margin: 8px 0;
}

.summary-info {
    font-size: 12px;
    color: #666;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    padding: 6px 8px;
    border-radius: 6px;
}

.summary-info .label {
    color: #888;
    display: flex;
    align-items: center;
}

.summary-info .value {
    font-weight: 600;
    color: #333;
}

.custom-handle {
    width: 14px;
    height: 14px;
    background: #bdbdbd;
    border: 3px solid white;
    border-radius: 50%;
    box-shadow: 0 0 0 1px #bdbdbd;
    transition: all 0.2s;
    cursor: crosshair;
}

.custom-node.selected .custom-handle {
    background: #2196f3;
    box-shadow: 0 0 0 1px #2196f3;
}
</style>
